<template>
    <form class="login" v-bind:action="apiUrl + '/login'" v-on:submit.prevent="handleSubmit">

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <span class="jam jam-newsletter is-large"></span>
            <input class="form__control is-large" id="email" type="email" autocomplete="off" placeholder="example@gmail.com"
                   v-model="email"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>
        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password">{{ __('Password') }}</label>
            <span class="jam jam-padlock-open is-large"></span>
            <input class="form__control is-large" id="password" type="password" autocomplete="off" placeholder="**********"
                   v-model="password"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.password">{{ errors.password[0] }}</small>

        <div class="is-clearfix">

            <div class="d-inline-block is-pulled-left">
                <router-link class="login__forgot-password-link"
                             v-bind:to="{ name: 'password.email' }"
                >
                    {{ __('Forgot password?') }}
                </router-link> <br />
                {{ __('Need an account?') }}
                <router-link class="login__register-link"
                             v-bind:to="{ name: 'register' }"
                >
                    {{ __('Sign up here.') }}
                </router-link>
            </div>
            <button class="btn is-primary is-pulled-right" type="submit">{{ __('Sign in') }}</button>
        </div>

        <span class="view__separator"><span>{{ __('or') }}</span></span>

        <a class="btn btn--facebook-login" v-on:click="handleSocialLogin('facebook')">
            <span class="jam jam-facebook"></span>
            {{ __('Sign in with Facebook') }}
        </a>
        <a class="btn btn--google-login" v-on:click="handleSocialLogin('google')">
            <span class="jam jam-google"></span>
            {{ __('Sign in with Google') }}
        </a>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                email: '',
                errors: {},
                password: ''
            }
        },
        methods: {
            handleSocialLogin: function (provider) {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/login/social/' + provider).then(function (response) {
                    window.location.replace(response.body.url);
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');

                eventBus.$emit('show-loader');

                this.$http.post(action, {
                    email: this.email,
                    password: this.password
                }).then(function (response) {
                    this.loginUser(response.body);

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    if (response.status == 429 && response.body.errors) {
                        this.errors = response.body.errors;

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                response.body.errors.email[0]
                        );
                    }

                    eventBus.$emit('hide-loader');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Login.vue